import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

const testimonials = [
  {
    name: 'Ramesh Shah',
    message: `Investing in mutual funds was confusing until I got expert advice. Now my savings are growing steadily without stress.`,
    image: '/images/user1.jpg',
  },
  {
    name: 'Seema Patel',
    message: `I started a SIP in a mutual fund last year. The consistency and compounding have been magical!`,
    image: '/images/user2.jpg',
  },
  {
    name: 'Karan Mehta',
    message: `Thanks to mutual funds, I now understand the importance of diversification and long-term investing.`,
    image: '/images/user3.jpg',
  },
  {
    name: 'Priya Desai',
    message: `My mutual fund advisor explained everything clearly. I'm now investing monthly and watching my portfolio grow.`,
    image: '/images/user4.jpg',
  },
  {
    name: 'Vikram Joshi',
    message: `I was skeptical at first, but mutual funds have turned out to be a great way to save for my child's education.`,
    image: '/images/user5.jpg',
  },
  {
    name: 'Anjali Rawat',
    message: `The power of SIP and mutual fund returns has made me financially confident for the first time.`,
    image: '/images/user6.jpg',
  },
];

const TestimonialSlider = () => {
  return (
    <div style={{ backgroundColor: '#69ff7042', padding: '60px 20px' }}>
      <div className="text-center mb-5">
        <h5 style={{ fontWeight: 400, letterSpacing: '1px' }}>Testimonials</h5>
        <h2 style={{ fontWeight: 700 }}>
          What Our Investors Say?
        </h2>
      </div>

      <Swiper
        modules={[Navigation, Autoplay]}
        navigation
        autoplay={{ delay: 5000 }}
        loop={true}
        slidesPerView={1}
      >
        {testimonials.map((item, index) => (
          <SwiperSlide key={index}>
            <div className="text-center px-4" style={{ maxWidth: 900, margin: '0 auto' }}>
              <img
                src={item.image}
                alt={item.name}
                className="rounded-circle mb-4"
                style={{ width: 100, height: 100, objectFit: 'cover' }}
              />
              <hr />
              <p className="text-muted fst-italic" style={{ fontSize: '18px', lineHeight: '1.8' }}>
                {item.message}
              </p>
              <h5 className="fw-bold mt-3">{item.name}</h5>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
    
  );
};

export default TestimonialSlider;
